/*import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    provideClientHydration(withEventReplay())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

*/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, isDevMode } from '@angular/core';
import { BrowserModule, provideClientHydration, withEventReplay} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Directionality } from '@angular/cdk/bidi';
import { DiscourseComponent } from './flashworlds/discourse.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { NeverumeComponent } from './neverume.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { ConnectionComponent } from './connection/connection.component';
import { ConfiditialPolicyComponent } from './confiditialpolicy/confiditialpolicy.component';
import { DocketsComponent } from './flashworlds/dockets.component';
import { RegistrationComponent } from './authentication/registration.component';
import { UploaderComponent } from './flashworlds/uploader.component';
import { VisionComponent } from './vision/vision.component';
import { VisitorAgreementsComponent } from './confiditialpolicy/visitoragreements.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PostnickComponent } from './flashworlds/postnick.component';
import { PostauthComponent } from './flashworlds/postauth.component';
import { PhotoStorageComponent } from './flashworlds/photostorage.component';
import { StreamComponent } from './flashworlds/stream.component';
import { ShiftsComponent } from './flashworlds/shifts.component';
import { ModalComponent } from './modal/modal.component';
import { DynamicComponentLoaderService } from './services/dynamic-component-loader.service';
import { EventRunner } from './core/app.core.events';
import { CborDataDecorator } from './core/app.core.cbor';
import { WebsocketService } from "./services/websocket.service";
import { ModalService } from './services/modal.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AvatarmakerComponent } from './flashworlds/avatarmaker.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FrameworksComponent } from './authentication/frameworks.component';


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
	ConfiditialPolicyComponent,
	DiscourseComponent,
	DocketsComponent,
	PhotoStorageComponent,
	StreamComponent,
	ShiftsComponent,
	AvatarmakerComponent,
	VisitorAgreementsComponent,
	NeverumeComponent,
	AuthenticationComponent,
	ConnectionComponent,
	RegistrationComponent,
	VisionComponent,
	PostnickComponent,
	PostauthComponent,
	ModalComponent,
	UploaderComponent,
	FrameworksComponent
  ],
  imports: [
    MatSelectModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatCardModule,
    MatSliderModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ImageCropperComponent,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
     provideClientHydration(withEventReplay())
    ,{
    provide: MatDialogRef,
    useValue: {}
  },
  {
    provide: MAT_DIALOG_DATA,
    useValue: {}
  },
  {
    provide: ReconnectingWebSocket,
    useValue: {}
  },

  PostnickComponent,
  Directionality,
  ModalComponent,
  NeverumeComponent,
  CborDataDecorator,
  DynamicComponentLoaderService,
  ModalService,
  EventRunner,
  { provide: WebsocketService },
  provideAnimationsAsync(),

  ],
  bootstrap: [NeverumeComponent]
})
export class AppModule {

}
